module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__content"
  }, [_c('button', {
    staticClass: "signin-button mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    attrs: {
      "id": "google-signin"
    }
  }, [_vm._v(_vm._s(_vm.signinText))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__media"
  }, [_c('img', {
    attrs: {
      "src": require("./gt-aim.png"),
      "alt": "GT AIM Logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h1', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("GT AIM")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce36a8d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Login/index.vue
// module id = 253
// module chunks = 0